import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { AccountTypeResponse } from "@/app/types";
import { format } from "date-fns";

// Helper component for the table header
export const DataTableColumnHeader = ({
  column,
  title,
}: {
  column: any;
  title: string;
}) => {
  return (
    <div className="flex items-center space-x-2">
      <span>{title}</span>
      {column.getCanSort() && (
        <button
          onClick={() => column.toggleSorting()}
          className="ml-1 rounded-md p-1 hover:bg-accent"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
          >
            <path d="m3 16 4 4 4-4" />
            <path d="M7 20V4" />
            <path d="m21 8-4-4-4 4" />
            <path d="M17 4v16" />
          </svg>
          <span className="sr-only">Sort</span>
        </button>
      )}
    </div>
  );
};

// Define columns for the AccountType data table
export const columns: ColumnDef<AccountTypeResponse>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => <DataTableColumnHeader column={column} title="ID" />,
    cell: ({ row }) => <div className="w-12">{row.getValue("id")}</div>,
  },
  {
    accessorKey: "name",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
    cell: ({ row }) => <div className="font-medium">{row.getValue("name")}</div>,
  },
  {
    accessorKey: "description",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Description" />,
    cell: ({ row }) => <div>{row.getValue("description") || "-"}</div>,
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Created At" />,
    cell: ({ row }) => {
      const date = row.getValue("created_at") as string;
      return <div>{date ? format(new Date(date), "PPP") : "-"}</div>;
    },
  },
];

// Define which columns can be searched by text
export const searchableColumns = [
  {
    id: "name",
    title: "Name",
  },
  {
    id: "description",
    title: "Description",
  },
]; 